import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_BLUE } from "../../config/constants";

const Connector12BBlue12CRed12DRed = ({ state, workState }) => (
	<g id="Track-12D-red" transform="translate(2101.000000, 381.000000)">
		<line
			x1="40" y1="58" x2="1" y2="72" id="line-copy-2"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			strokeWidth={tracksWidth}
			strokeLinecap="round"/>
	</g>
);

export default Connector12BBlue12CRed12DRed;
